export const API_URL = "http://localhost:3002";
export const TRUE_API_URL = "https://back-baqz.onrender.com";
